<template>
    <!--优惠券-->
    <div id="ordercoupon">
      <div class="main">
        <h2 class="title">
          可用优惠券
        </h2>
        <ul>
          <li v-for="(item, index) in couponData" :key="index" v-if="item.status !== 1" @click="chooseCoupon(item.vou_id, item.name, item.money)">
            <div class="left"><img :src="item.effective_background_img ? item.effective_background_img : item.invalid_background_img" alt=""></div>
            <div class="right">
              <h4><span class="tag">{{item.label}}</span>{{item.name}}</h4>
              <div class="date">
                <p>
                  截止日期：{{item.date_end}}
                </p>
                <a href="javascript:" :alt="item.vouchers_id">立即使用</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="bg" @click="hideSelf"></div>
    </div>
</template>

<script>
export default {
  name: 'OrderCoupon',
  data () {
    return {
      couponData: {}
    }
  },
  props: [
    'shopId',
    'shopType',
    'isSingle'
  ],
  mounted () {
    this.getCoupon()
  },
  methods: {
    getCoupon () {
      let data = {
        shop_id: this.shopId,
        shop_type: this.shopType,
        status: 0,
        is_single: this.isSingle
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_all_coupon',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.couponData = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    sendCoupon () {
      this.$emit('listenShow')
    },
    hideSelf () {
      this.$emit('listenShow')
    },
    chooseCoupon (id, name, money) {
      this.$emit('listenChoose', {vou_id: id, name: name, money: money})
    }
  }
}
</script>

<style scoped lang="stylus">
#ordercoupon
  .main
    position: fixed
    bottom: 0
    left: 0
    z-index: 1001
    width: 7.5rem
    padding: 0 0 .5rem
    background-color: #FAFAFA
    -webkit-border-radius: .32rem .32rem 0 0
    -moz-border-radius: .32rem .32rem 0 0
    border-radius: .32rem .32rem 0 0
  .title
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
  ul
    width: 6.54rem
    margin: 0 auto
    li
      position: relative
      display: flex
      justify-content: space-betwen
      align-items: center
      width: 6.54rem
      height: 1.8rem
      margin: .32rem 0 0
      .left
        width: 2.3rem
        height: 1.8rem
        img
          width: 100%
          height: 100%
      .right
        width: 4.24rem
        height: 1.8rem
        padding: 0 .12rem
        background-color: #fff
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        h4
          margin: .18rem 0
          font-size: .24rem
          color: #333
          text-align: left
          span.tag
            position: relative
            top: -.02rem
            display: inline-block
            width: .68rem
            height: .28rem
            line-height: .28rem
            // background:linear-gradient(90deg,rgba(122,209,255,1) 0%,rgba(43,183,255,1) 100%)
            background-color: #2BB7FF
            margin-right: .04rem
            font-size: .18rem
            color: #fff
            text-align: center
            -webkit-border-radius: .14rem
            -moz-border-radius: .14rem
            border-radius: .14rem
        .date
          display: flex
          justify-content: space-between
          align-items: center
          width: 100%
          height: .56rem
          border-bottom: .02rem dashed #E6E6E6
          margin: .46rem auto 0
          p
            font-size: .18rem
            color: #666
          a
            display: inline-block
            width: 1.1rem
            height: .4rem
            line-height: .4rem
            border: .02rem solid #2BB7FF
            font-size: .2rem
            color: #333
            text-align: center
            -webkit-border-radius: .2rem
            -moz-border-radius: .2rem
            border-radius: .2rem
      &.used, &.overdue
        .right h4 span.tag
          background-color: #ccc
        .right .date a
          display: none
        &::after
          content: "已使用"
          position: absolute
          top: .2rem
          right: .2rem
          display: block
          width: 1rem
          height: 1rem
          line-height: 1rem
          border: .02rem solid #ccc
          color: #ccc
          font-size: .3rem
          text-align: center
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          -webkit-transform: rotate(-35deg)
          -moz-transform: rotate(-35deg)
          -ms-transform: rotate(-35deg)
          -o-transform: rotate(-35deg)
          transform: rotate(-35deg)
      &.overdue
        &::after
          content: "已过期"
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: 1000
    width: 100%
    height: 100%
    background-color: #000
    opacity: .2
</style>



// WEBPACK FOOTER //
// src/components/order/OrderCoupon.vue